import { createContext, useContext } from 'react';
const DEFAULT_VALUE = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setVisible(_open) {
        printError();
    },
    visible: false,
};
Object.defineProperty(DEFAULT_VALUE, 'visible', {
    get() {
        printError();
        return false;
    },
});
function printError() {
    console.error('WalletModalProvider is not provided.' + 'Please wrap your components with WalletModalProvider.');
}
export const WalletModalContext = createContext(DEFAULT_VALUE);
export function useWalletModal() {
    return useContext(WalletModalContext);
}
//# sourceMappingURL=useWalletModal.js.map